import * as z from 'zod';

import { booleanFormSchema, NativeBooleanEnum, numericBooleanQuerySchema } from '@/_schemas/generic';

export const clientOptQuerySchema = numericBooleanQuerySchema();
type TClientOptQuerySchema = z.infer<typeof clientOptQuerySchema>;

export type ClientOptMutationSchema = z.infer<typeof clientOptQuerySchema>;

export const clientOptFormSchema = z.object({
  name: z.string(),
  value: booleanFormSchema(),
});

type ClientOptFormSchema = z.infer<typeof clientOptFormSchema>;

export const defaultClientOpt: ClientOptFormSchema = { name: 'No', value: false };

export const clientOptOptions: ClientOptFormSchema[] = [defaultClientOpt, { name: 'Yes', value: true }];

export function strToClientOptIn(clientOpt: TClientOptQuerySchema): ClientOptFormSchema {
  return clientOptOptions.find((option) => option.value === !!clientOpt) ?? defaultClientOpt;
}

export function clientOptInToStr(clientOpt: ClientOptFormSchema) {
  return clientOpt.value ? NativeBooleanEnum.True : NativeBooleanEnum.False;
}
